import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FooterState({ state, coord, withBullet = true, className = '', }) {
    return (_jsxs("div", { className: `
        flex items-center justify-between
        font-mono text-[8.5px] font-normal uppercase
        tracking-[0.2em] text-cyan-text-faint
        ${className}
      `, children: [_jsxs("span", { children: [withBullet ? _jsx("span", { "aria-hidden": true, children: "\u25CF " }) : null, state] }), _jsx("span", { children: coord })] }));
}
//# sourceMappingURL=FooterState.js.map